// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OTPInput{

    width: 50px;
    height: 8vh;
    text-align: center;
    font-size: medium;
    font-weight: bold;
    color: #03b4c6;
}

.OTPInput:hover{

    border:2px solid #03b4c6;

}`, "",{"version":3,"sources":["webpack://./src/MyComponents/ResetPassword/OTP.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;;AAE5B","sourcesContent":[".OTPInput{\n\n    width: 50px;\n    height: 8vh;\n    text-align: center;\n    font-size: medium;\n    font-weight: bold;\n    color: #03b4c6;\n}\n\n.OTPInput:hover{\n\n    border:2px solid #03b4c6;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
